export default __webpack_public_path__ + "static/media/45738-1000x830-1709594784673.6ba09723.jpg";